<template>
	<section v-show="isActive" :aria-hidden="!isActive ? true : null" class="tabs-component-panel new-style h-100" :class="{ 'has-toolbar': localButtons.length > 0, 'nk-minimal-page': getActiveState(`minimalPage_${id.split('_')[0]}`)?.value || false }" :id="hash" role="tabpanel">
		<div class="nk-tabs-component-panel-toolbar" v-if="localButtons.length > 0" tabindex="2" tabscope>
			<div class="nk-tabs-buttons-container">
				<div class="h-100 nk-tabs-button-item" v-for="(b, i) in localButtons" :key="b.id">
					<nk-print-button v-if="b.type == 'print'" :tabindex="i + 1" :options="b" @optionsChanged="buttonOptionsChanged"></nk-print-button>

					<nk-excel-button v-else-if="b.type == 'excel'" :tabindex="i + 1" @click="buttonClicked" :options="b"></nk-excel-button>

					<div v-else-if="b.type == 'seprator' && b.visible !== false" class="seprator mx-2"></div>

					<nk-button v-else-if="!b.items" :tabindex="i + 1" :options="b" @click="buttonClicked" @optionsChanged="buttonOptionsChanged"></nk-button>

					<nk-drop-button v-else-if="b.items" :tabindex="i + 1" :options="b" @click="buttonClicked" @optionsChanged="buttonOptionsChanged"></nk-drop-button>
				</div>
			</div>
		</div>
		<div v-if="(passive && isActive) || !passive" v-show="(!passive && isActive) || passive" class="nk-tabs-component-panel-scroll" ref="tab-panel" tabindex="0">
			<slot></slot>
		</div>
	</section>
</template>
<script>
	import _ from 'lodash'
	import { mapGetters } from 'vuex'

	export default {
		props: {
			id: { default: null },
			name: { required: true },
			prefix: { default: '' },
			suffix: { default: '' },
			isDisabled: { default: false },
			sticky: { default: false },
			buttons: { type: Array, default: () => ([]) },
			cachable: { type: Boolean },
			passive: { default: false, type: Boolean },
			query: { type: Object, default: () => ({}) }
		},
		emits: ['buttonsChanged'],
		data() {
			return {
				isActive: false,
				isVisible: true,
				isCached: false,
			}
		},
		computed: {
			...mapGetters({
				getActiveState: 'appStates/getActiveByKey',
			}),
			localButtons() {
				if (!this.buttons || this.buttons.length === 0) {
					return []
				}

				return this.buttons.filter(x => x.visible !== false)
			},
			header() {
				return this.prefix + this.name + this.suffix
			},
			hash() {
				if (this.isDisabled) {
					return '#'
				}

				return this.id
					? '#' + this.id
					: '#' + this.name.toLowerCase().replace(/ /g, '-')
			},
			isMinimalActive() {
				let state = this.getActiveState(`minimalPage_${this.id.split('_')[0]}`)
				return !!state?.value
			}
		},
		mounted() {
			this.$parent.tabs.push(this)
		},
		methods: {
			buttonClicked(button, e) {
				var handle = button.handle
				if (handle != null) {
					handle(button, null, e)
				}
			},
			buttonOptionsChanged(button) {
				const index = this.buttons.findIndex(x => x.id === button.id)
				if (index > -1) {
					_.extend(this.buttons[index], button)
					this.$emit('buttonsChanged', this.id, this.buttons)
				}
			},
		}
	}
</script>
